import { create } from 'zustand';
import { useAuthStore } from './authStore.js';

export interface PlanLimitInfo {
  feature?: string;
  limit?: number;
  used?: number;
  message?: string;
  /** Set when opening as a guest sign-up prompt */
  isGuestPrompt?: boolean;
}

interface PlanState {
  upgradeDialogOpen: boolean;
  limitInfo: PlanLimitInfo | null;
  openUpgradeDialog: (info?: PlanLimitInfo | null) => void;
  closeUpgradeDialog: () => void;
  isPlusOrAdmin: () => boolean;
}

export const usePlanStore = create<PlanState>((set) => ({
  upgradeDialogOpen: false,
  limitInfo: null,

  openUpgradeDialog: (info = null) =>
    set({
      upgradeDialogOpen: true,
      limitInfo: info ?? null
    }),

  closeUpgradeDialog: () =>
    set({
      upgradeDialogOpen: false,
      limitInfo: null
    }),

  isPlusOrAdmin: () => {
    const user = useAuthStore.getState().user;
    return Boolean(user && (user.role === 'ADMIN' || user.plan === 'PLUS'));
  }
}));

/** Reactive hook to check if user has Plus or Admin privileges */
export function useIsPlusOrAdmin(): boolean {
  const user = useAuthStore((s) => s.user);
  return Boolean(user && (user.role === 'ADMIN' || user.plan === 'PLUS'));
}
